<template>
	<div class="component-container">
		<div class="topBar" :style="{'background-image':'url('+ game_config.top_bar_background +')'}"></div>
		<div class="totalMoney">
			$<AnimatedNumber :number="totalMoneyDisplay" />
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import AnimatedNumber from '@/components/abstract/AnimatedNumber';

export default {
	name: 'TotalMoney',
	components: {
		AnimatedNumber,
	},
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
		totalMoneyDisplay() {
			return this.$store.state.totalMoney;
		},
		score() {
			return this.$store.state.score.toFixed(2);
		},
	},
};
</script>

<style lang="scss" scoped>
.component-container{
	pointer-events: none;
}
	.topBar{
		width: 100vw;
		height: 6.25%;
		left: 50%;
		transform: translateX(-50%);
		background-position: top left;
		background-color: transparent;
		background-repeat: repeat-x;
		background-size: auto 100%;
		-webkit-filter: blur(0px);
		position: absolute;
	}
	.totalMoney{
		width: 22%;
		height: 7%;
		padding-bottom: 0.3%;
		background-color: $gold;
		box-shadow: 0 0 0 5px #94671B, 0 0 0 10px black;
		font-weight: bold;
		text-align: center;
		display: flex;
		position: absolute;
		color: black;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 2.375em;
		justify-content: center;
		align-items: center;
		white-space: nowrap;
		@include breakpoint(lg) {
			font-size: 2em;
		}
		@include breakpoint(xmd) {
			font-size: 1.75em;
		}
		@include breakpoint(md) {
			box-shadow: 0 0 0 4px #94671B, 0 0 0 8px black;
			font-size: 1.5em;
		}
		@include breakpoint(sm) {
			box-shadow: 0 0 0 3px #94671B, 0 0 0 6px black;
			font-size: 1.25em;
		}
		@include breakpoint(xsm) {
			font-size: 1.0625em;
		}
		@include breakpoint(xs) {
			font-size: 0.9375em;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/TotalMoney.vue